import { Box, Grid, Stack, Typography } from "@mui/material"
import { getProvince } from "../../../utils"
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { dateSymbols } from "../../../../../dateSymbols";
import QRCode from '@mui/icons-material/QrCode2';

export const VLabel = ({ order, releaseDates }) => {
    const province = getProvince(order.school_address.province)
    const settings = JSON.parse(localStorage.getItem('zWarehouse'))

    let shape = <PriorityHighIcon sx={{ fontSize: 70 }} color='error' />
    releaseDates.forEach((item, idx) => {
        const value = Object.values(item)[0]
        if (value && value === order.release_date) {
            shape = dateSymbols[idx]
        }
    })

    return (
        <Box sx={{
            margin: '1em',
            border: '1px solid black',
            justifyContent: 'center'
        }}>
            <Box>
                <Stack align='center'>
                    <Stack spacing={2} sx={{ padding: '1em' }}>
                        <Typography variant='h3'>{order.grade}</Typography>

                        <Typography variant='h4'>
                            {order.school}
                        </Typography>

                        <Typography variant='h5'>
                            {order.city}, {province && province.code}
                        </Typography>
                    </Stack>

                    <Stack direction='row' sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderTop: '1px solid black'
                    }}>
                        <Box sx={{
                            width: '60%',
                            borderRight: '1px solid black',
                            alignItems: 'center',
                            minHeight: 70
                        }}>
                            <Grid container>
                                <Grid item xs={6} sx={{ paddingLeft: 2, paddingTop: 2 }}>
                                    <Stack align="left">
                                        <Typography fontWeight={600} fontSize={18}>Open Year Round</Typography>
                                        <Typography fontWeight={600} fontSize={18}>Next Day Shipping</Typography>
                                        <Typography fontWeight={600} fontSize={18}>100% Canadian</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={6}>
                                    {settings.qrcode && <QRCode  sx={{ fontSize: 120 }} />}
                                </Grid>
                            </Grid>
                            {/* <Typography variant='h4' mt={2}>
                                {orderId}
                            </Typography> */}
                        </Box>
                        <Box sx={{ width: '40%' }}>
                           {shape}
                        </Box>
                    </Stack>

                    <Box sx={{
                        borderTop: '1px solid black',
                        padding: '1em'
                    }}>
                        <img src='/assets/img/logo_text.jpg' alt='logo'
                            style={{
                                width: 300
                            }} />
                    </Box>
                </Stack>
            </Box>
        </Box>
    )
}
